import { combineReducers, configureStore } from '@reduxjs/toolkit';

import userSlice from 'redux/slices/user/userSlice';
import staffDetailsSlice from 'redux/slices/staff/staffDetailsSlice';
import staffSlice from 'redux/slices/staff/staffSlice';
import merchantBalanceSlice from 'redux/slices/dashboard/merchantBalanceSlice';
import qrCodeSlice from 'redux/slices/qr/qrCodeSlice';
import appSlice from 'redux/slices/common/appSlice';
import { RESET_REDUX } from './action/resetState';
import getMoneyContainerSlice from './slices/getMoneyContainerSlice';
import requestMoneyActivitySlice from './slices/sendAndRequest/requestMoneyActivitySlice';
import requestMoneyDetailSlice from './slices/sendAndRequest/requestMoneyDetailSlice';
import sendMoneyActivitySlice from './slices/sendAndRequest/sendMoneyActivitySlice';
import transactionDetailSlice from './slices/dashboard/transactionDetailSlice';
import accountActivitySlice from './slices/dashboard/accountActivitySlice';
import secretInfoSlice from './slices/user/secretInfoSlice';
import authRequestSlice from './slices/user/authRequestSlice';

import dailyLimitSlice from './slices/user/dailyLimitSlice';
// add seprate combineReducer of notification screen
const sendAndRequest = combineReducers({
    requestMoneyDetail: requestMoneyDetailSlice,
    requestActivityList: requestMoneyActivitySlice,
    sendMoneyActivityList: sendMoneyActivitySlice,
});

const dashboard = combineReducers({
    merchantBalance: merchantBalanceSlice,
});

const staff = combineReducers({
    staffList: staffSlice,
    staffDetail: staffDetailsSlice,
});

const rootReducer = combineReducers({
    user: userSlice,
    secretInfo: secretInfoSlice,
    authRequest: authRequestSlice,
    dailyLimit: dailyLimitSlice,
    staff,
    dashboard,
    qrCode: qrCodeSlice,
    app: appSlice,
    sendAndRequest,
    moneyContainer: getMoneyContainerSlice,
    accountActivity: accountActivitySlice,
    transactionDetail: transactionDetailSlice,
});
const appReducer = (state: any, action: any) => {
    if (action.type === RESET_REDUX) {
        // Call the rootReducer with undefined state and action for logout
        return rootReducer(undefined, action);
    }
    // For other actions, call the rootReducer with state and action
    return rootReducer(state, action);
};

export const store = configureStore({
    reducer: appReducer,
    devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
